// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  title: "刻名字的手机壳",
  beta: "测试版",
  phone: "手机型号",
  forPhone: (name) => `${name} 的手机壳`,
  material: "材料",
  materials: {
    flex: "软质（TPU）",
    rigid: "硬质（PETG）",
  },
  thick: "厚度",
  thicks: {
    slim: "超薄",
    standard: "标准",
    tough: "坚固",
  },
  fit: "松紧",
  fits: {
    tight: "紧密",
    normal: "刚好",
  },
  src: "背面图案",
  textHint: (lines, chars) => `最多 ${lines} 行，每行至多 ${chars} 个字符`,
  loadingFont: (family, got, total) => (total > 0 ? `正在加载 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在加载 ${family} ${got.toFixed(1)} MB`),
  finish: "图案风格",
  finishes: {
    flush: "平齐，双色",
  },
  turn: "方向",
  turns: {
    "0": "横排",
    "90": "竖排",
  },
  scale: "尺寸",
  pos: "位置",
  position: (v) => (Math.abs(v) < 0.005 ? '居中' : `${v > 0 ? '顶部' : '底部'} ${Math.round(Math.abs(v) * 100)}%`),
  needFile: "选择 SVG 文件——它只留在您的设备上，不会发送到任何地方",
  artKept: "图案只存在于当前标签页——刷新后需重新选择文件",
  keptOld: "（仍在使用先前的图案）",
  thumb: "已读取图案的预览",
  shareNoArt: "此链接不带 SVG 文件——打开的人需要自行选择文件",
  linkNeedsArt: "此设计使用了文件里的图案，但链接不带该文件——请选择 SVG 文件补上",
  gColour: "颜色",
  colourCase: "手机壳颜色",
  colourArt: "图案颜色",
  notes: {
    untested: (name, material) => `尚未在 ${material} 上做 ${name} 的打印测试`,
    settings: "背面朝下打印，无需支撑，0.2 毫米层高",
    tested: (name, material) => `已在 ${material} 上通过 ${name} 的打印测试`,
    proud: (mm) => `摄像头凸出背面 ${mm} 毫米——手机屏幕朝上放平时会晃`,
    flush: "平齐双色图案需要多色打印机和 3MF 文件（STL 不含图案，为闭合体）",
    engraved: "雕刻图案为单色，无需换料——STL 或 3MF 都可以",
    pla: "不建议用 PLA——扣上时易裂、手机发热时会变软；请用 TPU 或 PETG",
    terms: "仅供学习与个人使用——风险自负",
  },
  size: (x, y, z) => `手机壳尺寸 ${x.toFixed(1)} × ${y.toFixed(1)} × ${z.toFixed(1)} 毫米`,
  grams: (g) => `约重 ${Math.round(g)} 克`,
  views: {
    back: "背面",
    front: "正面",
    side: "侧面",
  },
  problem: {
    "no-art": "没有要打印的文字——得到素色手机壳",
    "thin-text": "字母很细——有些笔画可能打印不出来；请用更大的尺寸或减少字符",
    "same-colour": "图案颜色与壳身颜色相同——图案将看不到",
    "thin-parts": "图案的细笔画连着厚实部分——切片软件可能把它们切掉",
    dropped: (p) => `已从图案中丢弃 ${p.n} 个过薄、无法打印的部分`,
    "all-thin": "图案对这个尺寸来说太薄——无法下载",
    "art-too-complex": "图案太复杂——无法下载",
    "wide-groove": (p) => `凹槽宽于 ${p.mm} 毫米时，封住它的那层要悬空打印——背面可能不平；请减小图案尺寸或改用平齐双色`,
  },
  dlstl: "STL",
  copied: "已复制",
  fatal: "无法加载计算器——请尝试刷新页面",
  buildTimeout: "生成 10 秒未完成，已重新开始——请减少字符或换字体",
  aboutH2: "放名字手机壳的原理",
  aboutP1: "选 iPhone 16 Pro Max 或 iPhone 16 型号，放名字或标志 SVG 文件，下载 3MF 或 STL 去打印。手机壳背面朝下打印免支撑，边缘微微包住屏幕边框以扣住机身，并留出摄像头、Camera Control 按键和充电口的开孔。",
  aboutP2: "平滑款用两种颜色，图案是与壳面齐平的第三种颜色 — 需要多色打印机；雕刻款单色即可。SVG 文件只留在你的设备上，不会被发送到任何地方，也不会出现在复制的链接里。",
  aboutPrint: "松紧数值（机身周围的间隙、边缘深度）来自其他设计师的做法；尚未实际打印并装上真机验证，只通过了 OrcaSlicer 的模拟和切片。",
  aboutTerms: "这个工具用于学习和个人使用，未经手机厂商认可；打印出来的壳可能不合身或不防摔，风险由使用者自行承担。",
  aboutTrademark: "iPhone 是 Apple Inc. 的商标。这个工具不是 Apple 制作，也与 Apple 无关；型号名称只用于说明壳适配哪款设备。",
};
export default S;
